package net.gorillagroove.util

import kotlinx.serialization.json.*
import net.gorillagroove.api.defaultConfiguration
import net.gorillagroove.util.GGLog.logCrit

val ggJson = Json { this.defaultConfiguration() }

// This was mostly AI-generated because solving the kotlinx.serialization's inability
// to serialize the Any type did not sound fun. This class seems reasonable, but it's
// possible it's done something stupid. If you see something sus, it probably is.
object JsonMapConverter {

    fun stringToMap(jsonString: String): Map<String, Any> {
        if (jsonString.isBlank()) return emptyMap()

        return try {
            val jsonElement = ggJson.parseToJsonElement(jsonString)
            if (jsonElement is JsonObject) {
                jsonObjectToMap(jsonElement)
            } else {
                emptyMap()
            }
        } catch (e: Exception) {
            logCrit("Failed to convert String to Map!", e)
            throw e
        }
    }

    fun mapToString(map: Map<String, Any>): String {
        return try {
            val jsonObject = mapToJsonObject(map)
            ggJson.encodeToString(JsonObject.serializer(), jsonObject)
        } catch (e: Exception) {
            logCrit("Failed to convert Map to String!", e)
            throw e
        }
    }

    fun jsonObjectToMap(jsonObject: JsonObject): Map<String, Any> {
        return jsonObject.mapValues { (_, value) ->
            jsonElementToAny(value)
        }
    }

    private fun jsonElementToAny(element: JsonElement): Any {
        return when (element) {
            is JsonPrimitive -> {
                when {
                    element.isString -> element.content
                    element.booleanOrNull != null -> element.boolean
                    element.longOrNull != null -> element.long
                    element.doubleOrNull != null -> element.double
                    else -> element.content
                }
            }
            is JsonObject -> jsonObjectToMap(element)
            is JsonArray -> element.map { jsonElementToAny(it) }
        }
    }

    fun mapToJsonObject(map: Map<String, Any>): JsonObject {
        val content = map.mapValues { (_, value) ->
            anyToJsonElement(value)
        }
        return JsonObject(content)
    }

    private fun anyToJsonElement(value: Any): JsonElement {
        return when (value) {
            is String -> JsonPrimitive(value)
            is Number -> JsonPrimitive(value)
            is Boolean -> JsonPrimitive(value)
            is List<*> -> JsonArray(value.map { anyToJsonElement(it ?: JsonPrimitive("null")) })
            is Map<*, *> -> {
                @Suppress("UNCHECKED_CAST")
                val stringMap = value as? Map<String, Any> ?: return JsonPrimitive(value.toString())
                mapToJsonObject(stringMap)
            }
            else -> JsonPrimitive(value.toString())
        }
    }
}

fun String.parseJsonToMap(): Map<String, Any> = JsonMapConverter.stringToMap(this)
fun JsonObject.toMap(): Map<String, Any> = JsonMapConverter.jsonObjectToMap(this)
fun Map<String, Any>.toJsonString() = JsonMapConverter.mapToString(this)
fun Map<String, Any>.toJsonObject() = JsonMapConverter.mapToJsonObject(this)
